import Button from 'components/common/Button'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'

const WorkingWithTheAPI = () => {
  return (
    <Container className="py-4">
        <Heading className="mb-4">
            2. Working with the API
        </Heading>

        <div className="mb-4">
            <p className="mb-2">
                Solutions in React are prefered here, but not mandatory. You can also implement them in Vanilla JS.
            </p>

            <p className="mb-2">
                You will find the documentation for the API you will need to use in this task at https://openlibrary.org/developers/api.
            </p>
        </div>

        <Heading as="h3" className="mb-2">
            Tasks
        </Heading>

        <ul>
            <li>
                <Button type="link" size="" to="/working-with-the-api/display-full-info">
                    2a. Display full info
                </Button>
            </li>
            <li>
                <Button type="link" size="" to="/working-with-the-api/search-api">
                    2b. Search api
                </Button>
            </li>
        </ul>
    </Container>
  )
}

export default WorkingWithTheAPI